import { Down as DownArrow, Up as UpArrow } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';

interface StatusChangeProps {
  value: number;
}

const StatusChange = (props: StatusChangeProps) => {
  const { value } = props;

  const color = value < 0 ? 'var(--color-content-status-danger-secondary)' : 'var(--color-content-status-success-secondary)';
  const iconStyle = { width: '15px', height: '15px', color };
  const icon = value < 0 ? <DownArrow style={iconStyle} /> : <UpArrow style={iconStyle} />;
  const formattedValue = Number.isFinite(value) ? `${value.toFixed(2)}%` : 'NA';

  return (
    <Box sx={{ ...flex.itemsCenter }}>
      {icon}
      <Box sx={{ color, fontWeight: 600, fontSize: 13 }}> {formattedValue}</Box>
    </Box>
  );
};

export default StatusChange;
